"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @see https://github.com/NewAmsterdamLabs/svc-user/blob/development/api/src/main/java/com/zola/userservice/api/user/AwarenessChannel.java
 */
var userAwarenessChannelConstants = /*#__PURE__*/function (userAwarenessChannelConstants) {
  userAwarenessChannelConstants["BLOGS_ARTICLES"] = "BLOGS_ARTICLES";
  userAwarenessChannelConstants["BOUGHT_GIFT"] = "BOUGHT_GIFT";
  userAwarenessChannelConstants["FACEBOOK"] = "FACEBOOK";
  userAwarenessChannelConstants["FRIEND_FAMILY"] = "FRIEND_FAMILY";
  userAwarenessChannelConstants["GOOGLE_SEARCH"] = "GOOGLE_SEARCH";
  userAwarenessChannelConstants["INFLUENCER"] = "INFLUENCER";
  userAwarenessChannelConstants["INSTAGRAM"] = "INSTAGRAM";
  userAwarenessChannelConstants["NEWS"] = "NEWS";
  userAwarenessChannelConstants["ONLINE_AD"] = "ONLINE_AD";
  userAwarenessChannelConstants["OTHER"] = "OTHER";
  userAwarenessChannelConstants["PINTEREST"] = "PINTEREST";
  userAwarenessChannelConstants["PODCAST"] = "PODCAST";
  userAwarenessChannelConstants["PUBLICATION"] = "PUBLICATION";
  userAwarenessChannelConstants["REDDIT"] = "REDDIT";
  userAwarenessChannelConstants["SUBWAY"] = "SUBWAY";
  userAwarenessChannelConstants["TIKTOK"] = "TIKTOK";
  userAwarenessChannelConstants["TV_COMMERCIAL"] = "TV_COMMERCIAL";
  userAwarenessChannelConstants["WEDDING_BLOG"] = "WEDDING_BLOG";
  userAwarenessChannelConstants["WEDDING_VENDOR"] = "WEDDING_VENDOR";
  userAwarenessChannelConstants["YOUTUBE"] = "YOUTUBE";
  return userAwarenessChannelConstants;
}(userAwarenessChannelConstants || {}); // YouTube
var _default = exports.default = userAwarenessChannelConstants;